/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_UpdatedInputs */

const en_admin_permissions_updated = /** @type {(inputs: Admin_Permissions_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permission updated`)
};

const zh_admin_permissions_updated = /** @type {(inputs: Admin_Permissions_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`权限已更新`)
};

/**
* | output |
* | --- |
* | "Permission updated" |
*
* @param {Admin_Permissions_UpdatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_permissions_updated = /** @type {((inputs?: Admin_Permissions_UpdatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_UpdatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_permissions_updated(inputs)
	return zh_admin_permissions_updated(inputs)
});
export { admin_permissions_updated as "admin.permissions.updated" }